import React from 'react';

import { motion } from 'framer-motion';

import { LegacyCheckPurpleSmallIcon } from '@pkg/assets/icons/deprecated';
import { ReactComponent as ETH } from '@pkg/assets/images/artifacts/nft.svg';

import css from './SelectButton.module.css';

interface SelectButtonProps {
    className?: string;
    checked: boolean;
    minted?: boolean;
}

export function SelectButton({ className = '', checked, minted }: SelectButtonProps) {
    const icon = minted ? <ETH /> : checked ? <LegacyCheckPurpleSmallIcon /> : null;

    return (
        <motion.div
            className={`${css.button}  ${minted && css.buttonMinted} ${checked && css.buttonChecked} ${className}`}
            whileTap={{
                scale: 1.2,
                transition: {
                    damping: 50,
                    ease: 'linear',
                },
            }}
        >
            <div className={css.icon}>{icon}</div>
        </motion.div>
    );
}
